<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card v-if="!save_status">
        <v-card-title>
          <span class="headline">Mudança de permissão</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="formValid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field v-model="usuario.nomeUsuario" label="Nome" :disabled="true"
                    :rules="ruleNome"></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-select :items="roles" item-text="descricao" label="Selecione o role" item-value="descricao"
                    v-model="editedItem" :rules="obrigqtorioRules" :disabled="disabilitaRole" dense
                    return-object></v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="fecharComponente">Cancelar</v-btn>
          <v-btn color="blue darken-1" :disabled="!formValid" text @click="save">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../../plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");
export default {
  name: "mudarsenha",
  props: ["usuario"],

  data: () => ({
    text: "",
    flag_curso: "",
    flagUsuario: true,
    usuarios_permitidos: ls.get("usuarios_permitidos"),
    disabilitaRole: false,
    role_activo: ls.get("role"),
    save_status: false,
    formValid: true,
    roles: [
      { id: 2, descricao: "Secretário" },
      { id: 3, descricao: "ROLE_OPERADOR_CAIXA" },
    ],
    search: "",
    disativa: false,
    cursos: [],
    isLoading: false,
    funcionarios: [],
    obrigqtorioRules: [(value) => !!value || "campo obrigatório."],
    ruleNome: [
      (value) => value.length <= 50 || "Máximo número de carácteres atigidos",
      (value) => !!value || "campo obrigatório.",
    ],
    dialog: true,
    progresso: false,
    editedIndex: -1,
    editedItem: {
      idFuncionario: "",
      idPessoa: "", // bi
      email: "",
      nomeUsuario: "",
      autorizacoes_nome: "",
      enable: false,
      idusuario_autorizacao: "",
      newpassword: "",
      professor: 0,
      pkUsuario: 0,
      passwordnew: "",
    },
    defaultItem: {
      idFuncionario: "",
      idPessoa: "", // bi
      email: "",
      nomeUsuario: "",
      autorizacoes_nome: "",
      enable: false,
      idusuario_autorizacao: "",
      newpassword: "",
      professor: 0,
    },
  }),

  computed: {
    Instituicao() {
      return ls.get("i_id");
    },
    role() {
      return ls.get("role");
    },
    userNivel() {
      return ls.get("nivel_user");
    },
    fkUsuario() {
      return ls.get("pkUsuario");
    }
  },

  created() {
    this.InitializeRoles();
    if (this.usuario.autorizacoes_nome === "ROLE_EST")
      this.disabilitaRole = true;
    else this.disabilitaRole = false;
  },

  methods: {
    async InitializeRoles() {
      this.overlay = true;
      try {
        this.roles = await axios.get("/rolesFindAll").then((res) => res.data);
        if (this.userNivel) this.roles = this.roles.filter((r) => r.nivel >= this.userNivel);
      } catch (error) {
        Swal.fire("Ocorreu um erro ao carregar os roles.", "", "error");
      } finally {
        this.overlay = false;
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        let params = {
          idusuario_autorizacao: this.usuario.idusuario_autorizacao,
          autorizacoes_nome: this.editedItem.nome,
          fkUsuario: this.fkUsuario,
          email: this.usuario.email
        };
        try {
          let msg = await axios
            .post("/mudarPermissaoByUser", params)
            .then((res) => res.data);
          if (msg && msg.affectedRows) {
            Swal.fire(
              "Informação",
              "Operação realizada com sucesso",
              "success"
            );
          }
          this.fecharComponente();
        } catch (error) {
          this.fecharComponente();
          Swal.fire(
            "Informação",
            "Ocorreu um erro ao alterar o nível de acesso",
            "error"
          );
          this.dialog = false;
        }
        this.dialog = false;
      } // Fim do if do form
    },
    fecharComponente() {
      this.$emit("fecharComponente", false);
    },
  },
};
</script>
<style></style>
